import { SWEEPSTAKES_RESET_SUBMISSION_RESULT, SWEEPSTAKES_RESET_SUBMISSION_STATUS, SWEEPSTAKES_SET_PRIZE_ID, SWEEPSTAKES_SET_SUBMISSION_RESULT, SWEEPSTAKES_SET_SUBMISSION_STATUS, SWEEPSTATES_SET_LAST_SUBMISSION} from "../actions/sweepstakes";
export const STATE_NAME = 'sweepstakes';

export const initialState = {};

initialState[STATE_NAME] = {
	prizeId: null,
	lastSubmission: null,
	submissionResult: {},
	submissionStatus: null
};

function updateStateObj(state, key, val) {
	const nextState = {...state};
	nextState.sweepstakes = {...state.sweepstakes};
	nextState.sweepstakes[key] = val || nextState[STATE_NAME][key];
	
	return nextState;
}

export function setPrizeId(state, action) {
	const key = 'prizeId';
	return updateStateObj(state, key, (action && action.data));
}

export function setSubmissionResult(state, action) {
	const key = 'submissionResult';
	return updateStateObj(state, key, (action && action.data));
}

export function resetSubmissionStatus(state, action) {
	const key = 'submissionStatus';
	return updateStateObj(state, key, null);
}

export function setSubmissionStatus(state, action) {
	const key = 'submissionStatus';
	return updateStateObj(state, key, (action && action.data));
}

export function resetSubmissionResult(state, action) {
	const key = 'submissionResult';
	return updateStateObj(state, key, {});
}

export function setLastSubmission(state, action) {
	const key = 'lastSubmission';
	return updateStateObj(state, key, (action && action.data));
}

export default function reducer(state = initialState, action) {
	switch (action.type) {

		case SWEEPSTAKES_SET_PRIZE_ID:
			return setPrizeId(state, action);
		case SWEEPSTATES_SET_LAST_SUBMISSION:
			return setLastSubmission(state, action);
		case SWEEPSTAKES_SET_SUBMISSION_RESULT:
			return setSubmissionResult(state, action);
		case SWEEPSTAKES_RESET_SUBMISSION_RESULT:
			return resetSubmissionResult(state, action);
		case SWEEPSTAKES_SET_SUBMISSION_STATUS:
			return setSubmissionStatus(state, action);
		case SWEEPSTAKES_RESET_SUBMISSION_STATUS:
			return resetSubmissionStatus(state, action);
		default:
			return state;
	}
}